<template>
  <header>
    <div class="mobile-menu" :class="{open: mobile_menu}">
      <ul>
        <li><router-link :to="{ path: '/home' }">Kezdőlap</router-link></li>
        <li><router-link :to="{ path: '/palyazatok' }">Pályázatok</router-link></li>
      </ul>
    </div>
    <div class="container">
      <div class="logo-block">
        <router-link :to="{ path: '/' }"><img src="assets/img/logo.png" alt=""/></router-link>
        <div>
          <h2>KTR</h2>
          <div class="small">
            Kiválósági és Támogatási Rendszer
          </div>
        </div>
      </div>
      <div class="menu-block">
        <ul class="mainmenu">
          <li><router-link :to="{ path: '/home' }">Kezdőlap</router-link></li>
          <li><router-link :to="{ path: '/palyazatok' }">Pályázatok</router-link></li>
        </ul>
        <button :disabled="$root.shibbolethLoginOpen || $root.tmpLoginOpen" v-if="this.$root.user == ''" v-on:click="this.$root.openLoginPopup" type="button" class="button">Belépés</button>

        <div v-if="this.$root.user != ''" class="head-login-status">
          <div class="photo" :style="photoStyle"></div>
          <div class="name-and-type">
            <div class="name">
              {{ this.$root.user.name }}
            </div>
          </div>
          <a onclick="openProfilMenu();" class="menu" href="javascript:void(0)">
            <div class="item"></div>
            <div class="item"></div>
            <div class="item"></div>
          </a>
        </div>

        <a @click="openMobileMenu" href="javascript:void(0)" class="mobile-toggle">
          <i class="fa fa-bars"></i>
        </a>

      </div>
    </div>
    <div class="dark-line"></div>

  </header>
</template>
<script>
export default {
  data: function() {
    return {
      mobile_menu: false
    }
  },
  computed: {
    photoStyle: function() {
      return {
        'background-image': "url('"+(this.$root.user.avatar_base64 != undefined ? this.$root.user.avatar_base64 : '')+"')"
      }
    }
  },
  methods: {
    openMobileMenu: function() {
      this.mobile_menu = !this.mobile_menu;
    }
  }
}
</script>


// WEBPACK FOOTER //
// tpl_header.vue?119279a1